import {
  InvoiceCollection,
  type IBrand,
  type IInvoice,
  type IOrganisation,
  type IPatient,
  type ITransaction,
} from '@principle-theorem/principle-core/interfaces';
import {
  Firestore,
  collectionGroupQuery,
  orderBy,
  toTimestamp,
  where,
  type Query,
  type WithRef,
} from '@principle-theorem/shared';
import { BigQueryJobName } from '../../job-names';
import { ITransactionWriteTopicData } from '../../topic-data/topic-data';
import {
  BasicBigQuerySyncHandler,
  IBigQuerySyncRequest,
} from '../big-query-sync';

export class BigQueryTransactionsSyncHandler extends BasicBigQuerySyncHandler<
  ITransaction,
  ITransactionWriteTopicData
> {
  readonly bigQueryJobName = BigQueryJobName.TransactionWrite;

  getQuery(request: IBigQuerySyncRequest): Query<ITransaction<unknown>> {
    return collectionGroupQuery<ITransaction>(
      InvoiceCollection.Transactions,
      where('practiceRef', '==', request.practiceRef),
      where('createdAt', '>=', request.range.from),
      where('createdAt', '<=', request.range.to),
      orderBy('createdAt')
    );
  }

  async getTopicData(
    transaction: WithRef<ITransaction>
  ): Promise<ITransactionWriteTopicData> {
    const invoiceRef = Firestore.getParentDocRef<IInvoice>(transaction.ref);
    const patientRef = Firestore.getParentDocRef<IPatient>(invoiceRef);
    const brandRef = Firestore.getParentDocRef<IBrand>(patientRef);
    const organisationRef = Firestore.getParentDocRef<IOrganisation>(brandRef);

    return {
      organisation: await Firestore.getDoc(organisationRef),
      brand: await Firestore.getDoc(brandRef),
      practice: await Firestore.getDoc(transaction.practiceRef),
      patient: await Firestore.getDoc(patientRef),
      invoice: await Firestore.getDoc(invoiceRef),
      transaction,
      status: {
        before: transaction.status,
        after: transaction.status,
      },
      timestamp: toTimestamp(),
    };
  }
}
